<template>
  <div class="container password-reset-container">
    <div class="password-reset-div rounded shadow">
      <div class="logo-holder">
        <img :src="ProGoLoGo" alt="ProGoLoGo" class="img-fluid" style="width: 300px; margin: 0 auto; display: block;">
      </div>
      
      <div class="fw700 em2">Reset Password</div>

      <div class="input-group">
        <label for="resetEmail">Enter Your Email:</label>
        <input
          type="email"
          id="resetEmail"
          name="resetEmail"
          autocomplete="email"
          v-model.trim="resetEmail"
          required
        >
        <small :class="{ error: emailError }">{{ emailError || 'Please use your registered email address' }}</small>
      </div>
      
      <button class="reset-button" @click="sendPasswordReset" :disabled="isSending">
        {{ isSending ? 'Sending...' : 'Send Password Reset Email' }}
      </button>
      <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
      <br><br>

    </div>
  </div>
</template>

<script>
// Import the necessary Firebase function for password reset
import { auth } from '../main';
import { sendPasswordResetEmail } from 'firebase/auth';

import ProGoLoGo from '../assets/ProGoLoGo.png';

export default {
  name: "passwordResetPage",
  data() {
    return {
      ProGoLoGo,
      resetEmail: "",
      emailError: "",
      successMessage: "",
      isSending: false,
    }
  },
  methods: {
    async sendPasswordReset() {
      this.emailError = "";
      this.successMessage = "";

      if (!this.resetEmail) {
        this.emailError = "Email address is required";
        return;
      }
      
      try {
        this.isSending = true;
        const actionCodeSettings = {
          url: `${window.location.origin}/login`,
          handleCodeInApp: false,
        };
        await sendPasswordResetEmail(auth, this.resetEmail, actionCodeSettings);
        this.successMessage = "Password reset email sent successfully.";
      } catch (error) {
        console.log('Error:', error?.code, error?.message);
        const code = error?.code || "unknown";
        const messages = {
          "auth/invalid-email": "Please enter a valid email address.",
          "auth/user-not-found": "No account found for that email.",
          "auth/unauthorized-continue-uri": "The reset link URL isn't authorized in Firebase. Add this domain in Auth > Settings.",
          "auth/invalid-continue-uri": "The reset link URL is invalid. Check the domain in Auth > Settings.",
          "auth/too-many-requests": "Too many attempts. Try again later.",
        };
        this.emailError = messages[code] || "Error sending password reset email. Please check your email and try again.";
      }
      finally {
        this.isSending = false;
      }
    },
  }
}
</script>

<style scoped>
.logo-holder {
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  background: linear-gradient(90deg in oklab, blue, red);
}
.password-reset-container { 
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-group {
  margin-bottom: 20px;
}
.input-group label {
  display: block;
  margin-bottom: 5px;
}
.input-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.reset-button {
  width: 100%;
  padding: 10px;
  background: linear-gradient(90deg in oklab, blue, red);
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.reset-button:hover {
  background: linear-gradient(270deg in oklab, blue, red);
}
.password-reset-div {
  left: auto;
  margin-top: 50px;
  padding: 24px;
  width: 500px;
  height: 400px;
  background-color: var(--off_white);
}
.error {
  color: red;
}
.success-message {
  margin-top: 12px;
  color: #2e7d32;
  font-weight: 600;
}
</style>
